const rootStyles = getComputedStyle(document.documentElement);
const BREAKPOINT_SMALL_PX =
  parseFloat(rootStyles.getPropertyValue('--fg-screen-sm').trim()) || 640;

const BREAKPOINT_MEDIUM_PX =
  parseFloat(rootStyles.getPropertyValue('--fg-screen-md').trim()) || 768;

const BREAKPOINT_LARGE_PX =
  parseFloat(rootStyles.getPropertyValue('--fg-screen-lg').trim()) || 1024;

const BREAKPOINT_EXTRA_LARGE_PX =
  parseFloat(rootStyles.getPropertyValue('--fg-screen-xl').trim()) || 1280;

export {
  BREAKPOINT_EXTRA_LARGE_PX,
  BREAKPOINT_LARGE_PX,
  BREAKPOINT_MEDIUM_PX,
  BREAKPOINT_SMALL_PX,
};
